import { render } from "./cloudflare_video.vue?vue&type=template&id=09c938a7&scoped=true"
import script from "./cloudflare_video.vue?vue&type=script&lang=js"
export * from "./cloudflare_video.vue?vue&type=script&lang=js"

import "./cloudflare_video.vue?vue&type=style&index=0&id=09c938a7&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c938a7"]])

export default __exports__